import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  InvigilationattendanceColumns,
  InvigilationattendanceRows,
  fetchInvigilationattendanceRows,
} from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";
const InvigilatorAttendanceDataTable = () => {
  const [data, setData] = useState(InvigilationattendanceRows);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchInvigilationattendanceRows();
      console.log("jawad", rows);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);

  const handleDelete = (id) => {
    // Make a DELETE request to the Flask API endpoint
    fetch(`${serverUrl}/del_Invigilator_attendance/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete Invigilation attendance");
        }
        setData(data.filter((item) => item.id !== id));
        toast.success("Invigilation attendance deleted successfully!");
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const viewLinkString = "Invigilationattendance-Single";
  const editLinkString = "Invigilationattendance-Edit";

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/Invigilation-attendance/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/Invigilation-attendance/update-Invigilation-attendance/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle">Invigilator Attendance</div>
      {loading ? (
        // <h1 style={{ textAlign: "student", paddingTop: "20%" }}>loading...</h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={InvigilationattendanceColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
          }}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default InvigilatorAttendanceDataTable;
